import Vue from 'vue'
import axios from 'axios'

import VueLoading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
Vue.use(VueLoading)

export default {
	apiCall(url, data, method = 'post') {
		let loader = Vue.$loading.show({
			container: app,
			color: '#0088fa',
			loader: 'bars',
			width: 64,
			height: 64,
			backgroundColor: '#ffffff',
			opacity: 0.5,
		})

		return axios({
			method: method,
			url: url,
			data: data,
			headers: {
				
			},
		})
		.then((response) => {
			loader.hide()
			return response.data
		})
		.catch(error => {
			loader.hide()
			return error.response
		});
	}
}


// WEBPACK FOOTER //
// ./src/api.js